import React from 'react';
import { Breadcrumbs } from 'framework/ui/BreadCrumbs';
import { Link } from 'react-router-dom';
import { useStaffingProjectContext } from '../context/StaffingProjectContext';
import { VIEW_STAFFING_DASHBOARD } from 'domain/staffing/dashboard/constants';
import { useAuthorization } from 'framework/authorization';
import { useNewProjectUrl } from 'domain/shared/newProject';
import { STAFFING_DASHBOARD_PATH } from 'domain/shared/core/sharedRouteConstants';

const DashboardLinkItem = ({ entity, to }: { entity: string; to: string }) => <Link to={to}>{entity}</Link>;

const StaffingProjectBreadcrumbs = ({ children = null }: { children?: React.ReactNode | React.ReactNode[] | null }) => {
  const { project } = useStaffingProjectContext();
  const { isGranted } = useAuthorization();
  const { getDashboardUrl } = useNewProjectUrl();

  const dashboardPath = isGranted(VIEW_STAFFING_DASHBOARD) ? STAFFING_DASHBOARD_PATH : getDashboardUrl();

  return (
    <Breadcrumbs>
      <DashboardLinkItem entity="← Dashboard" to={dashboardPath} />
      {children ?? (project ? <span>{project.name ?? project.id}</span> : null)}
    </Breadcrumbs>
  );
};

export default StaffingProjectBreadcrumbs;
